<template>
  <div class="dz_json">
    <img v-if="!isLike" class="dz" :style="{width:width,height:height}" src="@/assets/image/shequ/dz.png" mode="scaleToFill" />
    <img v-else-if="isLike" class="dz" :style="{width:width,height:height}" src="@/assets/image/shequ/dz1.png" mode="scaleToFill" />
    <!-- <lottie v-show="isJson" :options="{
      animationData: require('@/assets/image/anijson/topicdz.json'),
      loop: false,
      autoplay: true
    }" :style="{width:width,height:height}" class="ani" ref="lottie"></lottie> -->
  </div>
</template>

<script>

export default {
  name: 'UniMailiangDzJSON',

  props: {
    src: {
      type: String,
      default: '@/assets/image/anijson/topicdz.json'
    },
    width: {
      type: String,
      default: '1.05rem'
    },
    height: {
      type: String,
      default: '1.05rem'
    },
    isLike: {
      default: false
    }
  },

  data() {
    return {
      isJson: false,
    };
  },

  mounted() {
   
  },

  methods: {
    play() {
      this.isJson = true
    },
    goToAndStop() {
      this.isJson = false
      // this.isJson = true
    }
  },
};
</script>

<style lang="scss" scoped>
.dz,.ani{
  display: block;
  margin-right: .05rem;
}
</style>